import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

export const Container = styled.div`
  position: relative;
  display: inline-block;
  width: 42px;
  height: 24px;
  pointer-events: none;
`;

export const ToggleIO = styled.div`
  /* slider */
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: ${theme.colors.secondary.gray500};
  transition: 0.3s;
  pointer-events: none;
  cursor: pointer;
  border-radius: 24px;

  &::before {
    content: '';
    position: absolute;
    height: 18px;
    width: 18px;
    left: 3px;
    top: 3px;
    background-color: ${theme.colors.primary.white};
    transition: 0.3s;
    pointer-events: none;
    border-radius: 34px;
  }

  svg {
    opacity: 0;
    position: absolute;
    left: 6px;
    top: 8px;
    transition: 0.3s;
  }
`;

export const ToggleInput = styled.input`
  opacity: 0;
  width: 100%;
  height: 100%;
  pointer-events: all;
  cursor: pointer;

  &:checked + ${ToggleIO} {
    background-color: ${theme.colors.primary.bariBlue};
  }

  &:checked + ${ToggleIO}::before {
    transform: translateX(18px);
  }

  &:disabled + ${ToggleIO} {
    background-color: ${theme.colors.secondary.gray400};
  }

  &:checked + ${ToggleIO} svg {
    opacity: 1;
    transform: translateX(18px);
    path {
      fill: ${theme.colors.primary.bariBlue};
      stroke: ${theme.colors.primary.bariBlue};
    }
  }

  &:disabled + ${ToggleIO} svg {
    path {
      fill: ${theme.colors.secondary.gray400};
      stroke: ${theme.colors.secondary.gray400};
    }
  }
`;
